<template>
    <v-col cols="12" md="6">
        <div class="w-100 h-100 border pa-20 pa-md-30 d-flex flex-column justify-center icon-box">
            <div class="d-flex d-lg-block justify-end">
                <v-img :src="icon" :max-width="iconWidth" class="icon-box-icon mb-6 mb-lg-0"></v-img>
            </div>
            <p class="font-weight-bold color-point font-size-16 font-size-lg-20 mb-2 mb-lg-48">
                {{num}}
            </p>
            <p class="color-grey-2c font-size-14 font-size-lg-16">
                <slot/>
            </p>
        </div>
    </v-col>
</template>

<script>

export default{
    props : {
        icon : {type :String, default : ""},
        iconWidth : {type :String, default : ""},
        num : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.icon-box{
    position: relative;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .icon-box{
        min-height: 188px;
    }
    .icon-box-icon{
        position: absolute;
        top: 30px;
        right: 30px;
    }
}
@media (min-width:1200px){
}

</style>